





































import { functions,auth, authObject} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'
import Notice from "@/components/Notice.vue"
import { Component,Mixins } from "vue-property-decorator";
import Common from '@/mixins/common';

@Component({
  components: {
    Notice,
  }
})

export default class AddSchool extends Mixins(Common) {
  isLoading = false
  schoolName = ''
  notice: NoticeProps = {} 
  
  get observer() {
    return this.$refs.addSchoolValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return ! this.schoolName
  }

  async created(){
    console.trace('created');
  }
 
 async mounted(){
  console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

  public async addSchool() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true
   
      const createSchool = functions.httpsCallable('createSchool');

      const data = {
        schoolName: this.schoolName,
        schoolId: this.$store.getters.schoolId
      }

      const newSchool = await createSchool(data)

      console.log(newSchool)

      if(auth.currentUser){
        await auth.currentUser.getIdToken(true)
      }

      this.notice = {
        message: this.$t('addSchool.added') as string,
        duration: 0,
        isShow: true,
        type: {'is-info': true}
      }

      this.schoolName = ''
      this.observer.reset()

      
      
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('addSchool.error') as string

      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){        
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
